import React, { FC, memo } from 'react';
import cx from 'classnames';
import './index.scss';
export const ArrowRight = memo((props) => {
    return <div className={cx('component-arrow-right', props.className)} />;
});
ArrowRight.defaultProps = {
    className: ''
};
export default ArrowRight;
